export default __webpack_public_path__ + "static/media/Icon.8ba6db83.svg";